import React from 'react';
import { Badge, Button, FlexWrapper, FontIcon, Separator, Text } from '@intigral/shared';
import styles from './program-card.module.sass';

type Button = {
    text: string;
    onClick: () => void;
    isActive: boolean;
};

interface AddWatchlistButtonProps {
    componentType?: string;
    componentName?: string;
    type?: string;
    item?: { paId?: string; Id?: string; programType?: string; category?: string };
    onRemove?: () => void;
    onClick?: () => void;
    watchlistButton?: boolean;
}

interface IProgramCard {
    channelNumber: number;
    channelName: string;
    duration: string;
    addWatchListButton: any;
    addToFavoriteButton: Button;
    description?: string;
    isLive?: boolean;
    epgLocalization?: any;
    liveTag?: string;
    beforeTag?: any;
    afterTag?: any;
    isBefore?: boolean;
    isAfter?: boolean;
    // PPV related props
    isPPV?: boolean;
    isPPVPurchased?: boolean;
    ppvEventId?: string;
    ppvPrice?: string;
    ppvCurrency?: string;
    onPPVPurchaseClick?: (eventId: string) => void;
}

export const ProgramCard = ({
    channelNumber,
    channelName,
    duration,
    description,
    addWatchListButton: addWatchListOrRemindButton,
    addToFavoriteButton,
    beforeTag,
    afterTag,
    liveTag,
    isLive = false,
    isBefore = false,
    isAfter = false,
    epgLocalization,
    // PPV props
    isPPV = false,
    isPPVPurchased = false,
    ppvEventId,
    ppvPrice,
    ppvCurrency,
    onPPVPurchaseClick,
}: IProgramCard) => {
    return (
        <FlexWrapper direction="column" gap="1x">
            <Text as="h2" variant="h2" alignment="start" margin="1x">
                <span className={styles['channel-number']}>{channelNumber}</span> {channelName}
            </Text>
            <FlexWrapper direction="row" gap="1x">
                <Text as="p" variant="text4" alignment="start" color="white" style={{ alignSelf: 'center' }}>
                    {duration}
                </Text>
                {isLive && (
                    <Badge live className={styles['live-badge']}>
                        {liveTag || 'Live'}
                    </Badge>
                )}
                {isBefore && beforeTag && (
                    <Badge tag className={styles['tag']}>
                        {beforeTag}
                    </Badge>
                )}
                {isAfter && afterTag && (
                    <Badge tag className={styles['tag']}>
                        {afterTag}
                    </Badge>
                )}
            </FlexWrapper>
            {description && (
                <Text as="p" variant="text3" alignment="start" color="gray" margin="2x">
                    {description}
                </Text>
            )}
            <div className="molded-buttons">
                {/* Show PPV Purchase Button if it's a PPV program and not purchased */}
                {isPPV && !isPPVPurchased && (
                    <Button
                        compact
                        onClick={() => {
                            if (onPPVPurchaseClick) {
                                // Use eventId if available, otherwise try to trigger purchase flow anyway
                                onPPVPurchaseClick(ppvEventId || 'unknown');
                            }
                        }}
                    >
                        {epgLocalization?.ppv_buy_now?.({ amount: ppvPrice, currency: ppvCurrency }) ||
                            (ppvPrice && ppvPrice !== '0' ? `Buy Now ${ppvPrice} ${ppvCurrency || ''}` : 'Buy Now')}
                    </Button>
                )}

                {addWatchListOrRemindButton}

                <Button compact secondary onClick={() => addToFavoriteButton.onClick()}>
                    <FontIcon
                        name={addToFavoriteButton.isActive ? 'heart-filled' : 'heart'}
                        size="small"
                        color={addToFavoriteButton.isActive ? 'orange' : 'gray'}
                    />
                    <span>{addToFavoriteButton.text}</span>
                </Button>
            </div>
        </FlexWrapper>
    );
};
